import { render, staticRenderFns } from "./ModuleContinueView.vue?vue&type=template&id=774c05c1&"
import script from "./ModuleContinueView.vue?vue&type=script&lang=js&"
export * from "./ModuleContinueView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports